var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfoTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Elements_info_tooltip",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 23.999,
    viewBox: "0 0 24.001 23.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(2.001 3)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_11",
    "data-name": "Subtraction 11",
    d: "M-8517,24a11.925,11.925,0,0,1-8.486-3.515A11.924,11.924,0,0,1-8529,12a11.924,11.924,0,0,1,3.516-8.485A11.924,11.924,0,0,1-8517,0a11.922,11.922,0,0,1,8.485,3.515A11.924,11.924,0,0,1-8505,12a11.924,11.924,0,0,1-3.514,8.485A11.922,11.922,0,0,1-8517,24Zm-.932-14.515V18h2.259V9.485Zm0-3.069V8.468h2.259V6.415Z",
    transform: "translate(8529.001)",
    fill: "var(--info-tooltip-color, #1049e5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoTooltip);
export default __webpack_public_path__ + "static/media/icon-info-tooltip.0635324f046524b00565ab49409290ea.svg";
export { ForwardRef as ReactComponent };